import { estimate, arrivalLabel, zonedNow, DAY_ACC, DAY_MS } from '@theme/delivery-date';

/**
 * <ship-note> — the dispatch half of the "Na stanju · …" line.
 *
 * The line used to read "šaljemo u roku od 24h" unconditionally, which is a
 * promise the shop cannot keep on a Saturday: Post Express does not collect at
 * the weekend, so an order placed Friday evening leaves on Monday. Same rules
 * and same module as the delivery estimate below it, so the two can never
 * disagree on the page.
 *
 * Rendered client-side on purpose — Shopify caches pages, and a server-rendered
 * "šaljemo danas" would still say that tomorrow.
 */
class ShipNote extends HTMLElement {
  connectedCallback() {
    this.cutoffMinutes = Number(this.dataset.cutoffHour || 12) * 60;
    this.holidays = new Set(
      (this.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean)
    );
    this.render();
    // A shopper sitting on the page across the cut-off should see it flip.
    this.timer = setInterval(() => this.render(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  render() {
    const { today, ship, arrive, shipsToday } = estimate({
      now: zonedNow(),
      cutoffMinutes: this.cutoffMinutes,
      holidays: this.holidays,
    });

    // data-mode="arrive": the PDP says when it arrives ("stiže sutra, u utorak"),
    // the one delivery line on the page since the separate estimate box went.
    if (this.dataset.mode === 'arrive') {
      this.textContent = `stiže ${arrivalLabel(today, arrive)}`;
      return;
    }

    if (shipsToday) {
      this.textContent = 'šaljemo danas';
    } else if (ship === today + DAY_MS) {
      this.textContent = 'šaljemo sutra';
    } else {
      this.textContent = `šaljemo u ${DAY_ACC[new Date(ship).getUTCDay()]}`;
    }
  }
}

if (!customElements.get('ship-note')) customElements.define('ship-note', ShipNote);
